import React, { useState } from 'react';
import { Box, type SxProps, type Theme } from '@mui/material';
import { VENDOR_DIRECTORY_GENERIC_PLACEHOLDER } from '../../utils/vendorDirectoryPlaceholders';

export type VendorImageProps = {
  src?: string | null;
  alt: string;
  fallbackSrc?: string;
  aspectRatio?: string;
  sx?: SxProps<Theme>;
  height?: number | string;
};

const VendorImage: React.FC<VendorImageProps> = ({
  src,
  alt,
  fallbackSrc = VENDOR_DIRECTORY_GENERIC_PLACEHOLDER,
  aspectRatio,
  sx,
  height,
}) => {
  const [currentSrc, setCurrentSrc] = useState(src || fallbackSrc);
  const [usedFallback, setUsedFallback] = useState(!src);

  const handleError = () => {
    if (!usedFallback && fallbackSrc) {
      setCurrentSrc(fallbackSrc);
      setUsedFallback(true);
    }
  };

  React.useEffect(() => {
    setCurrentSrc(src || fallbackSrc);
    setUsedFallback(!src);
  }, [src, fallbackSrc]);

  return (
    <Box
      component="img"
      src={currentSrc}
      alt={alt}
      onError={handleError}
      sx={{
        display: 'block',
        width: '100%',
        height: height ?? 'auto',
        objectFit: 'cover',
        aspectRatio,
        backgroundColor: 'action.hover',
        ...sx,
      }}
    />
  );
};

export default VendorImage;
